// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"327d7d98","404":"af3fa611","498":"ca869461","734":"a0df8b19","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};